import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Http } from "@angular/http";
import {
    ITCIHybridAgentList,
    ITCIHybridAgentStatusType,
    SERVICE_URLS,
    ITCIHybridAgentApps,
    ITCIIHybridAgentSpecList
 } from "@tci/common";
@Injectable()
export class BaseAgentListService {
    constructor(private http: Http) {
    }

    /* Get Hybrid agent list */
    getAgentList(): Observable<ITCIHybridAgentList[]> {
        const agentListUrl = SERVICE_URLS.AGENT_LIST;
        return this.http.get(agentListUrl).map(res => res.json())
        .catch(err => {
            console.log(`Unable to get hybrid agent list: ${err}`);
            return Observable.of([]);
        });
    }

    /**
     * Delete Hybrid agent
     * @param agentId
    */
    deleteAgent(agentId: string): any {
        const agentDeleteUrl = `${SERVICE_URLS.AGENT_DELETE}/${agentId}`;
        return this.http.delete(agentDeleteUrl).map(res => res.json())
        .catch(err => {
            let errMsg = { errorMsg: "Agent deletion failed" };
            if (err._body) {
                try {
                    errMsg = JSON.parse(err._body);
                } catch (e) {
                    console.log(`Unable to parse error body: ${e}`);
                }
            }
            return Observable.throw(errMsg);
        });
    }

    getAgentApps(): Observable<ITCIHybridAgentApps[]> {
        const agentAppsUrl = SERVICE_URLS.AGENT_APPS;
        return this.http.get(agentAppsUrl).map(res => res.json())
        .catch(error => {
            console.log(`Unable to get hybrid agent applications : ${error}`);
            return Observable.of([]);
        });
    }

    getAgentTunnelSpecs(agentIds: string[]): Observable<ITCIIHybridAgentSpecList[]> {
        const tunnelSpecsUrl = `${SERVICE_URLS.AGENT_TUNNEL_SPECS}`;
        return this.http.post(tunnelSpecsUrl, agentIds).map(res => res.json())
        .catch(error => {
            console.error(`Unable to get hybrid agent tunnel specs : ${error}`);
            return Observable.of([]);
        });
    }
}
